import { Button, Flex } from '@chakra-ui/react'
import React from 'react'

const PrimaryButton = React.forwardRef(
    ({ wrapperProps, children, disabled = false, ...props }, ref) => {
        return (
            <Flex className={'primary-button'} pt={'5px'} {...wrapperProps}>
                <Button top={'-5px'} {...props} ref={ref} isDisabled={disabled}>
                    {children}
                </Button>
            </Flex>
        )
    }
)

PrimaryButton.displayName = 'PrimaryButton'

export default PrimaryButton
